import { SidebarHeader, SidebarFooter } from '../ui/sidebar'
import { useSession } from '@/providers/SessionProvider'
import { UserTypes } from '@/configs/AppConfig'
import { NavUser } from '../nav-user'
import useNavbar from '@/hooks/use-navbar'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'



const getFirstSegment = (path) => {
    if (!path) return '/';

    const segments = path.split('?')[0].split('/').filter(Boolean);

    return segments.length > 0 ? `/${segments[0]}` : '/';
};

export const getActiveNavId = (navItems, currentPathname) => {
    const currentSegment = getFirstSegment(currentPathname);

    const activeItem = navItems.find((item) => {
        const itemSegment = getFirstSegment(item.url);
        return itemSegment === currentSegment;
    });

    return activeItem ? activeItem.id : null;
};

export default function Toolbar() {
    const { user, userType, rights } = useSession();
    const { navigation } = useNavbar(userType, rights)

    const location = useLocation();
    const activeId = getActiveNavId(navigation, location.pathname);

    return (
        <div className="z-49 shrink-0 sticky top-0 shadow-sm">
            <header className="bg-primary flex max-h-16 h-16 justify-between items-center gap-2 px-4">
                <SidebarHeader className="p-0">
                    <img src="/logo-text-turquoise.svg" className='h-11 w-auto object-contain' />
                </SidebarHeader>

                <div className="hidden md:flex items-center gap-3 ml-auto mr-4">
                    <div className="h-6 w-px bg-white/20" />
                    <p className="text-xs text-white/70 text-center leading-snug">
                        <span className="block font-medium text-white/90">Leonardo Center on</span>
                        <span className="block">Business for Society</span>
                    </p>
                </div>

                <SidebarFooter className="p-0">
                    <NavUser user={user} />
                </SidebarFooter>
            </header>

            {userType === UserTypes.SYSTEM_USER && navigation.length > 0 && (
                <nav className="w-full bg-white border-b border-gray-200">
                    <div className="flex items-center h-12 gap-0 px-4">
                        {navigation.map((item) => {
                            const isActive = item.id === activeId;
                            return (
                                <Link
                                    key={item.id}
                                    to={item.url}
                                    className="group relative flex items-center gap-2 px-5 h-full"
                                >
                                    <span className="opacity-100">
                                        {item.icon}
                                    </span>
                                    <span className={`text-xs font-medium transition-colors duration-150 ${isActive ? 'text-primary font-semibold' : 'text-black'}`}>
                                        {item.title}
                                    </span>
                                    {isActive && (
                                        <motion.div
                                            layoutId="nav-underline"
                                            className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary"
                                            transition={{ type: 'spring', stiffness: 400, damping: 35 }}
                                        />
                                    )}
                                </Link>
                            );
                        })}
                    </div>
                </nav>
            )}
        </div>
    )
}
